import Vue from "vue";
import { MinicartBrand } from "./miniCartBrand";

/**
 * MiniCart Brands Component
 */
const MinicartBrands = Vue.component("minicart-brands", {
    template: `
        <div class="minicart-brands">
            <minicart-brand v-for="(brand, index) in itemsSortedByBrand"
                :itemsSortedByBrand="itemsSortedByBrand"
                :key="brand.productBrandID"
                :brand="brand"
                :resources="resources"
                :trashIcon="trashIcon"
                :quantityInputIcons="quantityInputIcons"
                :brandsIcons="brandsIcons"
                :arrowUpIcon="arrowUpIcon"
                :arrowDownIcon="arrowDownIcon"
                :brandID="brandID"
                v-if="brand && brand.productBrandID && checkItems(brand.items)" />
        </div>
    `,
    components: {
        MinicartBrand
    },
    created() {
        this.itemsSortedByBrand.forEach((item, index) => {
            if (item.productBrandID == this.brandID) {
                if (index != 0) {
                    const element = this.itemsSortedByBrand.splice(index, 1)[0];
                    this.itemsSortedByBrand.splice(0, 0, element);
                }
            }
        });
    },
    watch: {
        itemsSortedByBrand() {
            this.itemsSortedByBrand.forEach((item, index) => {
                if (item.productBrandID == this.brandID && index != 0) {
                    const element = this.itemsSortedByBrand.splice(index, 1)[0];
                    this.itemsSortedByBrand.splice(0, 0, element);
                }
            });
        }
    },
    methods: {
        checkItems(items) {
            var itemsCount = 0;
            items.forEach(item => {
                if (item.id != this.resources.plasticBagID) {
                    itemsCount++;
                }
            });

            return itemsCount > 0 ? true : false;
        }
    },
    props: ["itemsSortedByBrand", "resources", "trashIcon", "quantityInputIcons", "brandsIcons", "arrowUpIcon", "arrowDownIcon", "brandID"]
});

export { MinicartBrands };
